import React, { useEffect } from "react";

import { FilterField } from "./Fields";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  TextField,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useCompany } from "../Companies/Provider";
import { FilterList } from "@mui/icons-material";
import { PlanEnum } from "../../utilities/Enum";
import { useMember } from "./provider";
import { useAuth } from "../../services/auth";
import { useSite } from "../Sites/Provider";
import { useSubCompany } from "../SubCompanies/Provider";
import styled from "styled-components";

const GridGroup1 = styled.div`
  width: fit-content;
  display: grid;
  padding: 20px;
  margin-bottom: 10px;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  grid-template-rows: 75px;
  grid-column-gap: 10px;
  background: #f7f9fb;
`;

const FilterForm = ({ form, error, setError }) => {
  const theme = useTheme();
  const { role, adminOn } = useAuth();

  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(null);

  const {
    state: { Names: companies },
    fetchNames: fetchCompany,
  } = useCompany();

  const {
    state: { selected: site, Names: listSitesNames },
    fetchSiteNames,
  } = useSite();
  const {
    state: { selected: subCompany },
  } = useSubCompany();
  const companyId = form.watch("id");

  const {
    state: { companyIdAtt, planIdAtt, page, perPage },
    fetchList,
    dispatch,
  } = useMember();
  useEffect(() => {
    if (role === "Admin") fetchCompany();
  }, [fetchCompany, role]);
  useEffect(() => {
  if(role==="Admin"||role==="Company")  fetchSiteNames(companyId);
 
  }, [role,companyId]);
    useEffect(() => {
      if (role === "SubCompany") fetchSiteNames(companyId, adminOn?.id);
    }, [role, companyId]);
  const getData = (name) => {
    const dataMap = {
      id: [
        ...(companies?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
      pid: [
        { id: 0, name: "All" },

        ...(PlanEnum?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
      siteId: [
        role !== "SubCompany" && { id: 0, name: "All" },
        ...listSitesNames.map(({ id, name }) => ({
          id: id,
          name: name,
        })),
      ],
    };

    return dataMap[name] || [];
  };
  useEffect(() => {
    if (role === "Company") {
      form.setValue("id", adminOn?.id);
      dispatch({ type: "set_companyIdAtt", payload: adminOn.id });
    }
  }, [role, form, adminOn, dispatch]);
  useEffect(() => {
    if (role === "Site") {
      form.setValue("id", site?.company?.id);
      dispatch({ type: "set_companyIdAtt", payload: site?.company?.id });
    }
  }, [role, form, adminOn, site, dispatch]);

  useEffect(() => {
    if (role === "SubCompany") {
      form.setValue("id", subCompany?.company?.id);
    }
  }, [role, form, adminOn, subCompany]);

  useEffect(() => {
    form.setValue("status", isActive);
  }, [isActive, form]);
  const onSubmit = async (values) => {
    setLoading(true);
    try {
      await fetchList(values.id, values.pid, values, page, perPage);
      setLoading(false);
    } catch (error) {
      setError(error.errors.message);
      setLoading(false);
    }
  };
  return (
    <form onSubmit={form.handleSubmit(onSubmit)} noValidate>
      <Box mb={1}>
        {error && (
          <Alert severity="error" sx={{ width: "70%" }}>
            {error}
          </Alert>
        )}
      </Box>
      <Box
        sx={{
          background: "#f7f9fb",
          padding: "10px 20px",
          width: "80%",
          mb: 3,
        }}
      >
        <GridGroup1>
          {role === "Company" && (
            <Box>
              <span style={{ fontSize: "12px" }}>Company Name</span>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "290px",
                  borderRadius: "8px",
                  textAlign: "center",
                  marginRight: "20px",
                  marginTop: "15px",
                }}
              >
                {adminOn?.companyName}
              </Box>
            </Box>
          )}
          {role === "Site" && (
            <Box>
              <span style={{ fontSize: "12px" }}>Company Name</span>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "290px",
                  borderRadius: "8px",
                  textAlign: "center",
                  marginRight: "20px",
                  marginTop: "15px",
                }}
              >
                {site?.company?.companyName}
              </Box>
            </Box>
          )}
          {role === "Site" && (
            <Box>
              <span style={{ fontSize: "12px" }}>Site Name</span>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "290px",
                  borderRadius: "8px",
                  textAlign: "center",
                  marginRight: "20px",
                  marginTop: "15px",
                }}
              >
                {site?.siteName}
              </Box>
            </Box>
          )}
          {role === "SubCompany" && (
            <Box>
              <span style={{ fontSize: "12px" }}>Company Name</span>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "290px",
                  borderRadius: "8px",
                  textAlign: "center",
                  marginRight: "20px",
                  marginTop: "15px",
                }}
              >
                {subCompany?.company?.companyName}
              </Box>
            </Box>
          )}
          {FilterField.map((f, index) => (
            <React.Fragment key={index}>
              {f.select ? (
                <FormControl
                  sx={{
                    minWidth: 120,
                    marginBottom: "20px",
                    marginRight: "10px",
                    display:
                      role !== "Admin" && f.name === "id"
                        ? "none"
                        : role === "Site" && f.name === "siteId"
                          ? "none"
                          : null,
                  }}
                >
                  <span style={{ fontSize: "12px" }}>{f.label}</span>
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                      ...form.register(f.name),
                      autoFocus: true,
                    }}
                    sx={{
                      fontSize: "12px",
                      width: "300px",
                      height: "40px",
                      marginTop: "14px",
                    }}
                    onChange={(e) => {
                      if (f.name === "id") {
                        dispatch({
                          type: "set_companyIdAtt",
                          payload: e.target.value,
                        });
                      } else {
                        dispatch({
                          type: "set_planIdAtt",
                          payload: e.target.value,
                        });
                      }
                    }}
                    defaultValue={f.name === "id" ? companyIdAtt : planIdAtt}
                  >
                    {getData(f.name)?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <>
                  {f.Switch ? (
                    <Box
                      display={"flex"}
                      justifyContent={"start"}
                      alignItems={"center"}
                      sx={{ mt: 4 }}
                    >
                      <Checkbox
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                      />
                      <span style={{ fontSize: "12px" }}>Active</span>
                    </Box>
                  ) : (
                    <Box>
                      <Box>
                        <p style={{ fontSize: "12px" }}>{f?.label}</p>
                        <TextField
                          InputProps={{
                            ...form.register(f?.name),
                          }}
                          error={!!form.errors?.[f?.name]}
                          helperText={form.errors?.[f?.name]?.message}
                          required
                          type={f?.type}
                          size="small"
                          sx={{
                            width: theme.dimensions.width,
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </>
              )}
            </React.Fragment>
          ))}
        </GridGroup1>
        <Box display={"flex"} justifyContent={"end"} mt={2}>
          <Button
            className="b"
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              backgroundColor: theme.color.blackBackground,
              color: "white",
              "&:hover": { background: `${theme.color.blackBackground}` },
              textTransform: "capitalize",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              <FilterList />
            )}
            <span>Filter</span>
          </Button>
        </Box>
      </Box>
    </form>
  );
};

export default FilterForm;
